/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Agenda_Card_OpenInputs */



/**
* | output |
* | --- |
* | "{title} — go to the conversation" |
*
* @param {Agenda_Card_OpenInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const agenda_card_open = /** @type {((inputs: Agenda_Card_OpenInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agenda_Card_OpenInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`${i?.title} — ga naar het gesprek`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.title} — aller à la conversation`)
	return /** @type {LocalizedString} */ (`${i?.title} — go to the conversation`)
});